import React from 'react';
import { ChatMessage } from '@/api/chat';
import { User, Bot, Clock, ExternalLink } from 'lucide-react';
import SourceCard from './SourceCard';

interface MessageBubbleProps {
  message: ChatMessage;
}

export default function MessageBubble({ message }: MessageBubbleProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div className={`flex max-w-[80%] ${isUser ? 'flex-row-reverse' : 'flex-row'} gap-3`}>
        <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isUser ? 'bg-blue-500' : 'bg-green-500'}`}>
          {isUser ? <User className="w-5 h-5 text-white" /> : <Bot className="w-5 h-5 text-white" />}
        </div>
        
        <div className={`flex-1 ${isUser ? 'items-end' : 'items-start'} flex flex-col`}>
          <div className={`p-3 rounded-lg ${isUser ? 'bg-blue-500 text-white' : 'bg-white border shadow-sm'}`}>
            <p className="whitespace-pre-wrap break-words">{message.content}</p>
            
            {!isUser && message.sources && message.sources.length > 0 && (
              <div className="mt-3 space-y-2">
                {message.sources.map((source, idx) => (
                  <SourceCard key={idx} source={source} />
                ))}
              </div>
            )}

            {!isUser && message.suggestedQuestions && message.suggestedQuestions.length > 0 && (
              <div className="mt-3 pt-3 border-t border-gray-200">
                <p className="text-xs text-gray-500 mb-2">追问建议：</p>
                <div className="space-y-1">
                  {message.suggestedQuestions.map((question, idx) => (
                    <button
                      key={idx}
                      className="w-full text-left px-3 py-2 text-sm bg-gray-50 hover:bg-gray-100 rounded-md transition-colors text-gray-700"
                    >
                      {question}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          
          <span className="text-xs text-gray-400 mt-1 px-1">
            {new Date(message.createdAt).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })}
          </span>
        </div>
      </div>
    </div>
  );
}
